import { IExample } from "../../../Components/Examples.Types";

import PageSimpleExample from "./examples/Page.Simple.Example";
import PageWithTabBarExample from "./examples/Page.TabBar.Example";
import PageWithProvidersExample from "./examples/Page.Providers.Example";
import PipelinesListingPageExample from "./examples/Page.PipelinesListing.Example";

export default [
    {
        title: "Basic page",
        component: PageSimpleExample,
        code: require("!raw-loader!./examples/Page.Simple.Example.tsx"),
        dependencies: {
            "Page.Example.css": require("!raw-loader!./examples/Page.Example.css"),
            "PageExampleData.ts": require("!raw-loader!./examples/PageExampleData.ts")
        },
        stretchContainer: true
    },
    {
        title: "Advanced page",
        component: PipelinesListingPageExample,
        code: require("!raw-loader!./examples/Page.PipelinesListing.Example.tsx"),
        dependencies: {
            "Page.Example.css": require("!raw-loader!./examples/Page.Example.css")
        }
    },
    {
        title: "Page with TabBar",
        component: PageWithTabBarExample,
        code: require("!raw-loader!./examples/Page.TabBar.Example.tsx"),
        dependencies: {
            "Page.Example.css": require("!raw-loader!./examples/Page.Example.css")
        },
        stretchContainer: true
    },
    {
        title: "Page with Providers",
        component: PageWithProvidersExample,
        code: require("!raw-loader!./examples/Page.Providers.Example.tsx"),
        dependencies: {
            "Page.Example.css": require("!raw-loader!./examples/Page.Example.css")
        },
        stretchContainer: true
    }
] as IExample[];
